// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deprecation-container {
  background-color: #f7f7f7;
  padding-bottom: 20px;
}
.deprecation-container h3 {
  color: #0d2b38;
  margin: 20px;
  font-size: 28px;
}
.deprecation-container p {
  color: #4d4d4f;
  margin: 0 20px;
  font-size: 16px;
}
.deprecation-container img {
  margin-top: 16px;
  width: 100%;
  max-width: 500px;
}
.deprecation-container .d-md-flex img,
.deprecation-container .d-flex img {
  width: 145px;
  margin-top: 0;
}
.deprecation-container a:focus {
  outline: none;
}
.deprecation-container .ml-20px {
  margin-left: 20px;
}
.deprecation-container .row > * {
  padding: 0;
}

.container-wrapper:has(> .deprecation-container) {
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/ImzDeprecationPage/index.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,oBAAA;AACF;AAAE;EACE,cAAA;EACA,YAAA;EACA,eAAA;AAEJ;AAAE;EACE,cAAA;EACA,cAAA;EACA,eAAA;AAEJ;AAAE;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;AAEJ;AAEI;;EACE,YAAA;EACA,aAAA;AACN;AAEE;EACE,aAAA;AAAJ;AAEE;EACE,iBAAA;AAAJ;AAEE;EACE,UAAA;AAAJ;;AAIA;EACE,UAAA;AADF","sourcesContent":[".deprecation-container {\n  background-color: #f7f7f7;\n  padding-bottom: 20px;\n  h3 {\n    color: #0d2b38;\n    margin: 20px;\n    font-size: 28px;\n  }\n  p {\n    color: #4d4d4f;\n    margin: 0 20px;\n    font-size: 16px;\n  }\n  img {\n    margin-top: 16px;\n    width: 100%;\n    max-width: 500px;\n  }\n  .d-md-flex,\n  .d-flex {\n    img {\n      width: 145px;\n      margin-top: 0;\n    }\n  }\n  a:focus {\n    outline: none;\n  }\n  .ml-20px {\n    margin-left: 20px;\n  }\n  .row > * {\n    padding: 0;\n  }\n}\n\n.container-wrapper:has(> .deprecation-container) {\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
